export const getStatusBadgeVariant = (status) => {
    switch (status) {
        case 'DRAFT':
            return 'warning';
        case 'IN_REVIEW':
            return 'incomplete';
        case 'PUBLISHED':
            return 'success';
        default:
            return 'common';
    }
};
export const getStatusLabel = (status, translate) => {
    switch (status) {
        case 'DRAFT':
            return translate('In progress');
        case 'IN_REVIEW':
            return translate('In Review');
        case 'PUBLISHED':
            return translate('Ready');
        default:
            return status;
    }
};
